import type { CalendarLinkState } from '../lib/calendarSync'

const labels: Record<CalendarLinkState, string> = {
  connecting: 'Connexion en cours',
  disconnected: 'Non connecte',
  syncing: 'Mise a jour en cours',
  synced: 'A jour',
}

/** Etat de la liaison d'un calendrier lie : sens interdit, roue qui tourne, ou coche verte. */
export default function CalendarSyncIcon({ state }: { state: CalendarLinkState }) {
  const common = { role: 'img', 'aria-label': labels[state], viewBox: '0 0 16 16', className: 'h-3.5 w-3.5 shrink-0' }

  if (state === 'disconnected') {
    return (
      <svg {...common} className={`${common.className} text-neutral-400 dark:text-neutral-600`}>
        <title>{labels[state]}</title>
        <circle cx="8" cy="8" r="7" fill="currentColor" />
        <rect x="3.5" y="6.75" width="9" height="2.5" rx="0.5" fill="white" />
      </svg>
    )
  }

  if (state === 'synced') {
    return (
      <svg {...common} className={`${common.className} text-green-600 dark:text-green-500`}>
        <title>{labels[state]}</title>
        <circle cx="8" cy="8" r="7" fill="currentColor" />
        <path d="M4.75 8.25 7 10.5l4.25-4.75" fill="none" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  return (
    <svg {...common} className={`${common.className} animate-spin text-neutral-500 dark:text-neutral-400`}>
      <title>{labels[state]}</title>
      <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.25" />
      <path d="M8 2a6 6 0 0 1 6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
